import graphql__c7eb5712b10b1602220e from "./__generated__/PageSectionBanner_pageSection.graphql.js";import { graphql, useFragment } from "react-relay";
import classNames from "classnames";

import SlideshowCarousel from "../Carousel/SlideshowCarousel";
import ContainerWithSidebar from "../Sidebar/ContainerWithSidebar";

const PageSectionBanner = props => {
  const pageSection = useFragment(PageSectionBanner_pageSection, props.pageSection);
  const { slides, autoplay, slidesInterval, sidebar, columnsRatio, columnsOrder } =
    pageSection;

  if (!slides.length) return null;

  const className = classNames([
    "page-section",
    "page-section-banner",
    "container",
    props.className
  ]);

  return (
    <div className={className}>
      <ContainerWithSidebar {...{ sidebar, columnsRatio, columnsOrder }}>
        <div className="box box-image">
          <SlideshowCarousel
            slides={slides}
            autoplay={autoplay}
            slidesInterval={slidesInterval}
          />
        </div>
      </ContainerWithSidebar>
    </div>
  );
};

const PageSectionBanner_pageSection = graphql__c7eb5712b10b1602220e;

export default PageSectionBanner;
